import React from 'react';
import { useIntl } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';
import FormValidationError from '@/components/errors/FormValidationError';
import { mapStateToProps, mapDispatchToProps } from '../components/DatasetConditionContainer';
import UserDefinedTextRestrictionEditor, {
  validateUserDefinedTextRestriction,
} from './UserDefinedTextRestrictionEditor';
import UserDefinedLinkRestrictionEditor, {
  validateUserDefinedLinkRestriction,
} from './UserDefinedLinkRestrictionEditor';
import UserDefinedAttachmentRestrictionEditor, {
  validateUserDefinedAttachmentRestriction,
} from './UserDefinedAttachmentRestrictionEditor';
import { UserDefinedRestrictionTypes } from '../constants';

const userDefinedRestrictionOptions = (intl) => [
  {
    key: UserDefinedRestrictionTypes.TEXT,
    text: intl.formatMessage({ id: 'dataset.condition.restriction.text' }),
    value: UserDefinedRestrictionTypes.TEXT,
  },
  {
    key: UserDefinedRestrictionTypes.LINK,
    text: intl.formatMessage({ id: 'dataset.condition.restriction.link' }),
    value: UserDefinedRestrictionTypes.LINK,
  },
  {
    key: UserDefinedRestrictionTypes.ATTACHMENT,
    text: intl.formatMessage({ id: 'dataset.condition.restriction.attachment' }),
    value: UserDefinedRestrictionTypes.ATTACHMENT,
  },
];

const userDefinedComponents = {
  [UserDefinedRestrictionTypes.TEXT]: {
    editor: UserDefinedTextRestrictionEditor,
    validator: validateUserDefinedTextRestriction,
  },
  [UserDefinedRestrictionTypes.LINK]: {
    editor: UserDefinedLinkRestrictionEditor,
    validator: validateUserDefinedLinkRestriction,
  },
  [UserDefinedRestrictionTypes.ATTACHMENT]: {
    editor: UserDefinedAttachmentRestrictionEditor,
    validator: validateUserDefinedAttachmentRestriction,
  },
};

export const validateUserDefinedRestriction = (datasetCondition, errors, isNew) => {
  userDefinedComponents[datasetCondition.context.type]?.validator(datasetCondition, errors, isNew);
};

const UserDefinedRestrictionPicker = ({
  datasetCondition,
  updateProperties,
}) => {
  const intl = useIntl();
  const FieldComponent = userDefinedComponents[datasetCondition.context.type]?.editor;

  return (
    <>
      <FormValidationError
        htmlFor="user_defined_restriction_type_dropdown"
        labelId="dataset.condition.user-defined.picker.label"
      >
        <Dropdown
          selection
          fluid
          value={datasetCondition.context.type}
          onChange={(e, { value }) => updateProperties({ type: value })}
          options={userDefinedRestrictionOptions(intl)}
        />
      </FormValidationError>
      <FieldComponent />
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDefinedRestrictionPicker);
